module.exports = __webpack_public_path__ + "static/media/information.4d96e7ee.svg";